import axiosIns from "@/api/axios";

export const GET_LIST_IN_REVIEW_IDP_LEARNING = (query) => {
  let url = "idp/structured-learnings/in-review";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const COMPLETE_STRUCTURED_LEARNING = (payload) => {
  const { id } = payload;

  let url = `/idp/structured-learnings/complete/${id}`;

  return axiosIns.get(url);
};

export const REVISE_STRUCTURED_LEARNING = (payload) => {
  const { id, note } = payload;

  let url = `/idp/structured-learnings/revise/${id}`;

  return axiosIns.post(url, { note });
};
